import { belowBreakpointOrEqual, fadeColor, getColor, styled } from "imaginarity-react-ui";

export class MediaSelectionSC {
    public static MSContainer = styled.div<{ width: string, background: string, border: string, aspect: number }>`
    width: ${p => p.width};
    height: fit-content;
    min-height:40px;
    background:${p => p.background};
    border: ${p => p.border};
    transition: 0.1s all ease-out;
    position: relative;
`;
    public static ImageEditContainer = styled.div`
`;
    public static ButtonBarImage = styled.div<{ darkMode: boolean, notSelected?: boolean }>`
    position: absolute;
    height: 41px;
    top: 0;
    left: 0px;
    right: 0px;
    background: ${p => p.darkMode ? fadeColor(p, getColor(p, p.theme.colors.darkerGrey), 50) : fadeColor(p, getColor(p, p.theme.colors.middleLightGrey), 70)};
    border-bottom: 1px solid ${p => getColor(p, p.theme.colors.accent)};
    box-shadow: ${p => p.notSelected ? "none" : "0 6px 8px -6px #000"};
`;
    public static ButtonBarVideo = styled(MediaSelectionSC.ButtonBarImage)`
`;
    public static ButtonBarAudio = styled(MediaSelectionSC.ButtonBarImage)`
`;
    public static ImageEditImage = styled.div`
    position: absolute;
    top:0;
    left:0;
    bottom:0;
    right:0;
`;
    public static ImageEditImageAudio = styled.div`
    position: absolute;
    bottom:0px;
    left:0px;
    right:0px;
`;
    public static Spacer1 = styled.div`
    float: left;
    height: ${props => belowBreakpointOrEqual(props, "mobile") ? "25px" : "40px"};
    margin-top:0px;
    width:5px;
    border-right:1px solid ${p => getColor(p, p.theme.colors.middleLightGrey)};
`;
    public static Spacer2 = styled.div`
    float: left;
    height: ${props => belowBreakpointOrEqual(props, "mobile") ? "25px" : "40px"};
    width:5px;
`;
    public static Spacer3 = styled.div`
    float: right;
    height: ${props => belowBreakpointOrEqual(props, "mobile") ? "25px" : "40px"};
    margin-top:0px;
    width:5px;
    border-left:1px solid ${p => getColor(p, p.theme.colors.middleLightGrey)};
`;
    public static Spacer4 = styled.div`
    float: right;
    height: ${props => belowBreakpointOrEqual(props, "mobile") ? "25px" : "40px"};
    width:5px;
`;
    public static Left = styled.div`
    float: left;
`;
    public static Right = styled.div`
    float: right;
`;
    public static AspectConatiner = styled.div`
    float: left;
    width: 90px;
    height: 40px;
    padding: 1px;
    background: ${p => getColor(p, p.theme.colors.darkGrey)};
    margin-top: 0px;
`;
    public static ActionButtons = styled.div`
    width: 100%;
    margin-top: ${props => belowBreakpointOrEqual(props, "mobile") ? "7px" : "0px"};
`;
    public static ActionButtonsCrop = styled.div`
    float: left;
    max-width: fit-content;
    margin-top: ${props => belowBreakpointOrEqual(props, "mobile") ? "7px" : "0px"};
`;
    public static FilterButtonContainer = styled.div`
    float: left;
    ${props => belowBreakpointOrEqual(props, "tablet") && "width:  180px;"};
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    margin-top: 0;
`;
    public static SVG = styled.div<{ imageUrl: string, aspect: number }>`
        //background: rgba(0,0,0,0.05);
        background-image: url('${p => p.imageUrl}');
        background-repeat: no-repeat;
        background-position: center center;
        background-size: contain;
        position: relative;
        padding-bottom: calc(100% / ${p => p.aspect});
`;

    public static FilterButtonElement = styled.div<{ image: string }>`
    height: ${props => belowBreakpointOrEqual(props, "mobile") ? "40px" : "40px"};
    width: ${props => belowBreakpointOrEqual(props, "mobile") ? "40px" : "40px"};
    flex: 0 0 auto;
    cursor: pointer;
    background-image: url('${props => props.image}');
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    margin-right:0px;
    transition: 0.2s all ease-out;
        div{
            display:none;
        }
    &:hover{
        width: ${props => belowBreakpointOrEqual(props, "mobile") ? "25px" : "120px"}; 
        box-shadow: ${props => belowBreakpointOrEqual(props, "mobile") ? "none" : "0 3px 3px -2px #000"};
        position: relative;
        div{
            display: ${props => belowBreakpointOrEqual(props, "mobile") ? "none" : "unset"};
            position: absolute;
            bottom: 0;
            left:0;
            width:100%;
            background: rgba(0,0,0,0.7);
            color: #FFF;
            line-height: 20px;
            font-size:0.9rem;
            height:20px;
            text-align: center;
            overflow: hidden;
        }
    }
`;
}